"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugSettingsSelection = DebugSettingsSelection;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const StyledInput = styled_components_1.default.input `
  vertical-align: middle;
`;
const StyledFieldset = styled_components_1.default.fieldset `
  border: 1px solid #d3d3d3;
  border-radius: 5px;

  font-size: 12px;

  padding: 10px;

  legend {
    padding: 10px;
  }
`;
const settings = [
    {
        label: "Server logging",
        propertyName: "includeServerLog",
        isAllowedForRestricedDev: true
    },
    {
        label: "Show property ids",
        propertyName: "showPropertyIds",
        isAllowedForRestricedDev: false
    },
    {
        label: "Show hidden properties",
        propertyName: "showHiddenProperties",
        isAllowedForRestricedDev: true
    },
    {
        label: "Show hidden results",
        propertyName: "showHiddenResults",
        isAllowedForRestricedDev: true
    },
    {
        label: "ShowTextDb",
        propertyName: "showTextDb",
        isAllowedForRestricedDev: false
    },
    {
        label: "ShowTextsWithTextId",
        propertyName: "showTextsWithTextId",
        isAllowedForRestricedDev: false
    }
];
function DebugSettingsSelection({ debugSettings, isRestrictedDeveloper, setDebugProperties }) {
    const handleCheckboxChange = (propertyName) => {
        setDebugProperties(Object.assign(Object.assign({}, debugSettings), { [propertyName]: !debugSettings[propertyName] }));
    };
    const filteredSettings = isRestrictedDeveloper
        ? settings.filter((x) => x.isAllowedForRestricedDev)
        : settings;
    return (React.createElement(StyledFieldset, null,
        React.createElement("legend", null, "Debug settings"),
        Object.keys(debugSettings).map((key) => {
            const setting = filteredSettings.find(({ propertyName }) => propertyName === key);
            if (!setting) {
                return null;
            }
            const { label, propertyName } = setting;
            return (React.createElement("div", null,
                React.createElement(StyledInput, { type: "checkbox", key: propertyName, checked: debugSettings[propertyName], onChange: () => handleCheckboxChange(propertyName) }),
                label));
        })));
}
//# sourceMappingURL=debug-settings-selection.js.map